module.exports = __webpack_public_path__ + "img/grosvenor-casinos.e98c6fa3.png";